/* eslint-disable no-param-reassign */
import {createAsyncThunk, createSlice} from '@reduxjs/toolkit'
import {http} from 'hiya-common/src/utils/axios'

export const getSeason = createAsyncThunk(
  'LudoQualifying/getSeason',
  async (p: any, store: any) => {
    const resp = await http.post('/gamestore/common/season_rank', {
      ...store.getState().env.deviceinfo,
      ...p,
      limit: 10,
      offset: 0,
    })
    return resp.data
  }
)

export const getGoto = createAsyncThunk(
  'LudoQualifying/getGoto',
  async (p: any, store: any) => {
    const resp = await http.post('/gamestore/common/season_rank_goto', {
      ...store.getState().env.deviceinfo,
      ...p,
    })
    return resp.data
  }
)

interface Season {
  rank_h5_bg_url: string
  season_time: string
  desc: string
}

const initialState: {
  season: Season
} = {
  season: {
    rank_h5_bg_url: '',
    season_time: '',
    desc: '',
  },
}

export const LudoQualifyingSlice = createSlice({
  name: 'LudoQualifying',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getSeason.fulfilled, (state, action) => {
      const {data = {}} = action.payload
      Object.assign(state, data)
    })
  },
})

export default LudoQualifyingSlice.reducer
